import React from 'react';

import './styles.scss';

interface TooltipItem {
  title: string;
  value: string;
}

interface TooltipProps {
  items: TooltipItem[];
}

const Tooltip: React.FC<TooltipProps> = ({ items }) => {
  return (
    <div className="tooltip-container">
      {items.map((item: TooltipItem, index: number) => (
        <div key={index} className="tooltip-item">
          <div className="label">{item.title}</div>
          <div className="value">{item.value}</div>
        </div>
      ))}
    </div>
  );
};

export default Tooltip;
